module.exports = (arr = []) => arr.filter(({ published_at, published }) => published_at || published)
